import { useEffect } from 'react';
import { setTiresiasUserContext, type TiresiasUserContext } from './featbit';

/**
 * Keeps the Tiresias (FeatBit) evaluation context in sync with the current user identity.
 *
 * Call it once per app, from the root providers. Whenever any field changes the context is
 * re-sent to every Tiresias domain, so flags re-evaluate with the new user, brand and `path`.
 *
 * Nothing is sent while there is no `keyId`: the FeatBit client already starts as `anonymous`.
 * It is safe to call before the providers are ready: the identity is kept and used to initialise
 * the FeatBit client, and pushed to each domain once it is ready.
 */
export function useTiresiasIdentity(identity: TiresiasUserContext | null | undefined) {
	const keyId = identity?.keyId ?? null;
	const name = identity?.name ?? null;
	const managementCode = identity?.managementCode ?? null;
	const path = identity?.path ?? null;

	useEffect(() => {
		if (!keyId) return;

		setTiresiasUserContext({ keyId, name, managementCode, path });
	}, [keyId, name, managementCode, path]);
}
